import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/domain/client';
import { ClientService } from 'src/app/service/client/client.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ViaCep } from 'src/app/domain/viacep';
import { State } from 'src/app/domain/state';
import { City } from 'src/app/domain/city';
import { AddressService } from 'src/app/service/address/address.service';
import { UtilsService } from 'src/app/service/utils/utils.service';

@Component({
  selector: 'app-client-view',
  templateUrl: './client-view.component.html',
  styleUrls: ['./client-view.component.css']
})
export class ClientViewComponent implements OnInit {


  id: number;
  client: Client = new Client();
  loading: boolean = true;


  constructor(
    private service: ClientService,

    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id']
    });
  }

  ngOnInit(): void {
    this.getClient();

  }



  getClient() {
    this.loading = true;
    this.service.getClient(this.id).subscribe(data => {
      this.client = data;
      this.loading = false;

    },
      error => {
        this.loading = false;
        this.openAlertError();
      });
  }

  openAlertError() {
    Swal.fire('Ops...', 'Ocorreu um erro ao carregar o Cliente!', 'error');
  }

}
